module.exports = __webpack_public_path__ + "img/service.c81f8142.svg";